import zhCN from 'root/locale/zh-cn.json';
import enUS from 'root/locale/en-us.json';
import zhHK from 'root/locale/zh-hk.json';

export const LOCALE_ZHCN = 'zh-cn';
export const LOCALE_ENUS = 'en-us';
export const LOCALE_ZHHK = 'zh-hk';

export const moduleResources = [
  {
    locale: LOCALE_ZHCN,
    messages: zhCN,
  },
  {
    locale: LOCALE_ENUS,
    messages: enUS,
  },
  {
    locale: LOCALE_ZHHK,
    messages: zhHK,
  },
];
